export function isEmpty(array) {
  return !Array.isArray(array) || !array.length
}

export function sortArrayByPropName(array, propName) {
  return array.sort((a, b) => {
    if (a[propName] < b[propName]) {
      return -1
    }
    if (a[propName] > b[propName]) {
      return 1
    }
    return 0
  })
}

export function sortVariantSkusBySize(skus) {
  const orderedSkus = []
  let sizesAreNumbers = false
  skus.forEach(function(skuData) {
    if (isNaN(Number(skuData.size))) {
      orderedSkus.push(skuData)
    } else {
      sizesAreNumbers = true
      orderedSkus.unshift(skuData)
    }
  })
  return sizesAreNumbers
    ? orderedSkus.sort((left, right) => Number(left.size) - Number(right.size))
    : orderedSkus
}
